import { render, staticRenderFns } from "./UpgradePlanForFeatureModal.vue?vue&type=template&id=a1c90524&"
import script from "./UpgradePlanForFeatureModal.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanForFeatureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports